module.exports = __webpack_public_path__ + "static/media/data-selected.d37f6915.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-selected.svg
// module id = 179
// module chunks = 0